import { graphql } from '@api/generated/gql';

export const getRecordingsDefaultsQuery = graphql(`
  query GetRecordingDefaults {
    recordingDefaults {
      globalRecordingOverrideSettings {
        recordingSetting
        overrideBehavior
      }
      queueRecordingDefaults {
        recordingSettings
        announceRecordingStatus
      }
      individualRecordingDefaults {
        inboundRecordingSettings
        inboundAnnounceRecordingSettings
        outboundRecordingSettings
        outboundAnnounceRecordingSettings
      }
      transferRecordingDefaults {
        transferToQueue
        transferToIndividual
      }
      recordingDefaultsExclusions {
        phoneNumbers
        areaCodes
      }
    }
  }
`);

export const getGlobalRecordingOverrideSettings = graphql(`
  query GetGlobalRecordingOverrideSettings {
    globalRecordingOverrideSettings {
      recordingSetting
      overrideBehavior
    }
  }
`);

export const updateGlobalRecordingOverrideMutation = graphql(`
  mutation updateGlobalRecordingOverride(
    $input: GlobalRecordingOverrideInput!
  ) {
    updateGlobalRecordingOverride(input: $input) {
      globalRecordingOverrideSettings {
        recordingSetting
        overrideBehavior
      }
    }
  }
`);

export const updateIndividualRecordingsDefaultsMutation = graphql(`
  mutation updateIndividualRecordingDefaults(
    $input: IndividualRecordingDefaultsInput!
  ) {
    updateIndividualRecordingDefaults(input: $input) {
      individualRecordingDefaults {
        inboundRecordingSettings
        inboundAnnounceRecordingSettings
        outboundRecordingSettings
        outboundAnnounceRecordingSettings
      }
    }
  }
`);

export const updateQueueRecordingsDefaultsMutation = graphql(`
  mutation updateQueueRecordingDefaults($input: QueueRecordingDefaultsInput!) {
    updateQueueRecordingDefaults(input: $input) {
      queueRecordingDefaults {
        recordingSettings
        announceRecordingStatus
      }
    }
  }
`);

export const updateTransferRecordingsDefaultsMutation = graphql(`
  mutation updateTransferRecordingDefaults(
    $input: TransferRecordingDefaultsInput!
  ) {
    updateTransferRecordingDefaults(input: $input) {
      transferRecordingDefaults {
        transferToQueue
        transferToIndividual
      }
    }
  }
`);
